export function hasFeature(doc, name) {
    return (doc?.features || []).includes(name);
}

export default hasFeature;
